import { render, staticRenderFns } from "./sentPost.vue?vue&type=template&id=258c409d"
import script from "./sentPost.vue?vue&type=script&lang=js"
export * from "./sentPost.vue?vue&type=script&lang=js"
import style0 from "./sentPost.vue?vue&type=style&index=0&id=258c409d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports